import script from "./LangSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=554de6fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554de6fe"]])

export default __exports__